<div class="construction-documents-wrapper">
  <app-gc-header
    [iconName]="'filePdf'"
    [titleString]="'constructionDocuments'"
  />
  <ng-content />
</div>
